import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Worksheet, WorksheetItem, WorksheetQuery, WorksheetService, WorksheetType } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';

interface BenefitsVideo {
  item: WorksheetItem;
  worksheetId: number;
}

@Component({
  selector: 'fgb-membership-benefits',
  templateUrl: './membership-benefits.component.html',
  styleUrls: ['./membership-benefits.component.scss'],
})
export class MembershipBenefitsComponent implements OnInit {
  productCode = ProductCode;

  video$: Observable<BenefitsVideo | undefined>;

  constructor(private worksheetService: WorksheetService, private worksheetQuery: WorksheetQuery, private router: Router) {}

  ngOnInit() {
    const currentUrl = this.router.url.replace('/', '').split('?')[0];

    this.video$ = this.worksheetQuery.getWorksheetByRoute(currentUrl).pipe(map((worksheets) => this.firstVideo(worksheets)));
    if (!this.worksheetQuery.hasRoute(currentUrl)) {
      firstValueFrom(this.worksheetService.fetchWorksheetByRoute(currentUrl));
    }
  }

  private firstVideo(worksheets: Worksheet[]): BenefitsVideo | undefined {
    for (const group of worksheets) {
      const item = group.Items?.find((worksheetItem) => worksheetItem.WorksheetType === WorksheetType.ProviderVideo);
      if (item) {
        return { item, worksheetId: group.WorksheetId };
      }
    }

    return undefined;
  }
}
